import { RegionType } from '@/api/apis/facilities';
import { NameByValue } from '@/types';

const HeartLungsRegionList = ['Midwest', 'Northeast', 'South', 'West', 'Europe'];
const LiverRegionList = ['Midwest', 'Northeast', 'South', 'Southeast', 'West', 'Europe'];

export const getFormattedRegionsList = (regionsList?: RegionType[]): NameByValue[] =>
  regionsList?.map((region: RegionType) => ({
    value: region.id,
    name: region.name,
  })) || [];

export const getFormattedLiverRegionsList = (regionsList?: RegionType[]): NameByValue[] =>
  regionsList
    ?.map((region: RegionType) => ({
      value: region.id,
      name: region.name,
    }))
    .filter((region) => LiverRegionList.includes(region.name)) || [];

export const getFormattedHeartLungsRegionsList = (regionsList?: RegionType[]): NameByValue[] =>
  regionsList
    ?.map((region: RegionType) => ({
      value: region.id,
      name: region.name,
    }))
    .filter((region) => HeartLungsRegionList.includes(region.name)) || [];
